import packageJson from '../../package.json'

// TODO: when all env vars are complete, remove the ?? "" and add !
const Config = {
  BASE_URL: import.meta.env.VITE_BACKEND_URL ?? '/api',
  F3TC_ENVIRONMENT: import.meta.env.VITE_F3TC_ENVIRONMENT ?? 'int',

  WEB_EAM_BASE_URL: import.meta.env.VITE_WEB_EAM_BASE_URL ?? '',
  WEB_EAM_REALM_PATH: import.meta.env.VITE_WEB_EAM_REALM_PATH,
  WEB_EAM_CLIENT_ID: import.meta.env.VITE_WEB_EAM_CLIENT_ID ?? '',
  WEB_EAM_REDIRECT_URI:
    import.meta.env.VITE_WEB_EAM_REDIRECT_URI ?? `${window.location.origin}/oauth/callback`,

  B2BC_CONSENT_PORTAL_BASE_URL:
    import.meta.env.VITE_B2BC_CONSENT_PORTAL_BASE_URL ??
    'https://b2bconnect.bmwgroup.com/consent/remote-charging-control',
  B2BC_CONSENT_PORTAL_FLEET_ID: import.meta.env.VITE_B2BC_CONSENT_PORTAL_FLEET_ID ?? '',
  B2BC_CONSENT_PORTAL_REDIRECT_URL:
    import.meta.env.VITE_B2BC_CONSENT_PORTAL_REDIRECT_URL ?? `${window.location.origin}/vehicles`,
}

export const APP_VERSION = packageJson.version

export default Config
